import React from 'react'
import {LoadingEllipsis} from 'common/Loading'

import {useQuery} from 'hooks'
import {queryMe} from 'graph'

const SessionContext = React.createContext<any>({})

export const SessionProvider = ({clearCache, children}: any) => {
	const {loading, data, refetch} = useQuery(queryMe, {
		fetchPolicy: 'cache-and-network',
		// Keep the cached session when offline (a network error must not blank `me`).
		errorPolicy: 'all',
	});

	if (!data && loading) {
		return <LoadingEllipsis />
	}

	const session = {...data, refetch, clearCache}
	return (
		<SessionContext.Provider value={session}>
			{children}
		</SessionContext.Provider>
	)
}
export const SessionConsumer = SessionContext.Consumer
export default SessionContext
